import {createRoot, hydrateRoot} from 'react-dom/client';
import ToolReviews from '../pages/ToolReviews/ToolReviews'
import "../index.css";
import "../pages/ToolReviews/ToolReviews.module.css"

type AnyProps = Record<string, any>;

let root:
   | ReturnType<typeof createRoot>
    | ReturnType<typeof hydrateRoot>
        | null = null;

function mount(el: HTMLElement, props: AnyProps = {}) {
console.log("Rendering......")
root = createRoot(el);
root.render(<ToolReviews {...(props as any)}/>);
}

function hydrate(el: HTMLElement, props: AnyProps = {}) {
console.log("Hydrating......")
root = hydrateRoot(el, <ToolReviews {...(props as any)}/>);
}

function unmount() {
root?.unmount?.();
root = null;
}

if (typeof window !== 'undefined') (window as any).ToolReviewsVC = {mount, hydrate, unmount}